import { useEffect, useMemo, useRef } from "react";

export function stableStringify(value) {
  try {
    return JSON.stringify(value);
  } catch {
    return "";
  }
}

/**
 * True when `values` differ from the snapshot taken when the drawer opens.
 * Bump `resetKey` after async form init so the loaded state becomes the baseline.
 */
export function useDrawerBaselineDirty(open, values, resetKey = 0) {
  const baselineRef = useRef(null);

  useEffect(() => {
    if (!open) {
      baselineRef.current = null;
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    baselineRef.current = stableStringify(values);
  }, [open, resetKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(() => {
    if (!open || baselineRef.current === null) return false;
    return stableStringify(values) !== baselineRef.current;
  }, [open, values]);
}

export default useDrawerBaselineDirty;
